import React, { useState, useEffect } from 'react';
import { couponAPI } from '../../services/api';
import '../../styles/shared.css';
import './CouponsPage.css';

interface Coupon {
  id: number;
  name: string;
  code: string;
  discount_type: 'percentage' | 'fixed';
  discount_value: number;
  min_order_amount: number;
  max_discount_amount: number | null;
  valid_from: string;
  valid_until: string;
  status: 'unused' | 'used' | 'expired';
}

const CouponsPage: React.FC = () => {
  const [coupons, setCoupons] = useState<Coupon[]>([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('unused');

  const tabs = [
    { key: 'unused', label: '未使用' },
    { key: 'used', label: '已使用' },
    { key: 'expired', label: '已过期' }
  ];

  useEffect(() => {
    fetchCoupons();
  }, [activeTab]);

  const fetchCoupons = async () => {
    try {
      setLoading(true);
      const data = await couponAPI.getMyCoupons(activeTab);
      setCoupons(data);
    } catch (error) {
      console.error('获取优惠券失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDiscount = (coupon: Coupon) => {
    if (coupon.discount_type === 'percentage') {
      return `${coupon.discount_value}%折扣`;
    } else {
      return `¥${coupon.discount_value}减免`;
    }
  };


  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString();
  };

  if (loading) return <div className="loading">加载中...</div>;

  const getCouponClassName = (coupon: Coupon) => {
    let className = 'coupon-item';
    if (coupon.status === 'used') className += ' used';
    if (coupon.status === 'expired') className += ' expired';
    return className;
  };

  return (
    <div className="page-container coupons-page">
      <div className="page-header">
        <div className="header-content">
          <h1>我的优惠券</h1>
        </div>
      </div>

      <div className="content-container">
        <div className="coupons-tabs">
          {tabs.map(tab => (
            <button
              key={tab.key}
              className={`tab ${activeTab === tab.key ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="coupons-list">
          {coupons.length === 0 ? (
            <div className="empty-state">
              <p>暂无优惠券</p>
            </div>
          ) : (
            coupons.map(coupon => (
              <div key={coupon.id} className={getCouponClassName(coupon)}>
                <div className="coupon-content">
                  <div className="coupon-left">
                    <div className="coupon-price">{formatDiscount(coupon)}</div>
                    <div className="coupon-name">{coupon.name}</div>
                    <div className="coupon-desc">满¥{coupon.min_order_amount}可用</div>
                  </div>
                  
                  <div className="coupon-right">
                    <div className="coupon-date">有效期至 {formatDate(coupon.valid_until)}</div>
                    {coupon.status !== 'unused' && (
                      <div className="coupon-status">
                        {coupon.status === 'used' ? '已使用' : '已过期'}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default CouponsPage;